export default "__VITE_ASSET__BeczKyx2__"